import { isArray } from "lodash";

export interface QueryParams {
  [key: string]: string | string[] | boolean;
}

/**
 * A query string with its values percent-encoded.
 *
 * Lives in its own module so it can be tested without constructing the API client, which
 * the service module does at import time.
 *
 * Every value used to be an id, a flag or a timestamp, so raw interpolation was latent
 * rather than wrong. Server-side search changed that: "Smith & Sons" split the parameter
 * at the `&` and the server searched for "Smith" plus a junk ` Sons` param, and "Unit #3"
 * was truncated at the fragment and searched as "Unit ". Wrong results, labelled with the
 * right total, on the headline feature of this branch — and cached under the full term, so
 * the wrong rows come back on a repeat search.
 *
 * Keys are encoded too: they are ours today, but an unencoded key is the same bug waiting.
 */
export const getQueryStringFromParams = (query: QueryParams) => {
  return Object.keys(query).reduce((acc, curr) => {
    const currVal = query[curr];
    const key = encodeURIComponent(curr);
    let queryString = "";
    if (isArray(currVal)) {
      queryString = (currVal as string[]).map((val) => `${key}=${encodeURIComponent(val)}`).join("&");
    } else {
      queryString = `${key}=${encodeURIComponent(String(currVal))}`;
    }
    return query[curr] || query[curr] === false ? `${acc}${acc ? "&" : ""}${queryString}` : acc;
  }, "");
};
